import React, { useState, useEffect } from 'react'
import { toast } from 'react-toastify';
import Loading from '../general/Loading';
import '../css/Admin/SubscriptionPlan.css';
import '../css/Admin/MyInsights.css';
import InsightImg from '../assets/insight-1.jpeg';

const MyInsights = () => {
  const [isEditMode, setIsEditMode] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [insights, setInsights] = useState([]);
    const [selectedIns, setSelectedIns] = useState(null);
    const [showDelete, setShowDelete] = useState(false);
      const [myIndex, setMyIndex] = useState([]);
    
  
    const [formData, setFormData] = useState({
      title: '',
      images: [],
      description: '',
      category: '',
      impact: '',
      type: 'Insight'
    });
  

  useEffect(() => {
        fetchIndexes();
    fetchInsights();
  }, []);
  
    
      const fetchIndexes = async () => {
        setLoading(true);
        try {
          const response = await fetch('https://api.tradeintell.com/get-indexes');
          if (response.ok) {
            const data = await response.json();
            setMyIndex(data);
          } else {
            console.error('Failed to fetch topics');
          }
        } catch (error) {
          console.error('Error fetching data:', error);
        } finally {
          setLoading(false);
        }
      };
  
  const fetchInsights = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.tradeintell.com/get-edu-insights');
      if (response.ok) {
        const data = await response.json();
        setInsights(data);
      } else {
        console.error('Failed to fetch insights');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };


const handleImageChange = (e) => {
  const files = Array.from(e.target.files);
  if (!files.length) return;

  const maxSize = 2 * 1024 * 1024;

  for (let file of files) {
    if (file.size > maxSize) {
      toast.error('Each image must be less than 2MB');
      e.target.value = null;
      return;
    }
  }

  setFormData({
    ...formData,
    images: files,
  });
};




const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formData.title || !formData.description) {
    toast.error('Please fill all required fields.');
    return;
  }

  try {
    setLoading(true);

    const apiUrl = isEditMode
      ? `https://api.tradeintell.com/edit-insight/${selectedIns.id}`
      : 'https://api.tradeintell.com/create-insight';

    const payload = new FormData();
    payload.append('title', formData.title);
    payload.append('description', formData.description);
    payload.append('category', formData.category);
    payload.append('impact', formData.impact);
    payload.append('type', 'Insight');

   if (formData.images.length > 0) {
  formData.images.forEach((img) => {
    payload.append('images', img);
  });
}


    const response = await fetch(apiUrl, {
      method: isEditMode ? 'PUT' : 'POST',
      body: payload,
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Something went wrong');
    }

    toast.success(isEditMode ? 'Insights Updated.' : 'New Insight Added.');

    setShowForm(false);
    setIsEditMode(false);
    setSelectedIns(null);
    setFormData({
      title: '',
      image: [],
      description: '',
      category: '',
      impact: '',
      type: 'Insight',
    });

    fetchInsights();
  } catch (error) {
    toast.error(error.message || 'Something went wrong. Try again.');
  } finally {
    setLoading(false);
  }
};

  
    const handleManage = (plan) => {
      setShowForm(true);
      setIsEditMode(true);
      setSelectedIns(plan);
      setFormData({
              title: plan.title,
      images: [],
      description: plan.description,
      category: plan.category ?? '',
      impact: plan.impact ?? '',
      type: 'Insight'
      });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };
  

const formatDate = (timestamp) => {
  const date = new Date(timestamp);
  const options = {
    day: '2-digit',
    month: 'short', // short month name, e.g., "Dec"
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,   // 12-hour format with AM/PM
  };
  return date.toLocaleString('en-US', options);
};


const handleRemove = async (tId) => {
  try {
    const response = await fetch(`https://api.tradeintell.com/remove-insight/${tId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }

    const data = await response.json();
        toast.success('Insight Deleted Successfully.');
        setShowDelete(false);
        setSelectedIns('');
        fetchInsights();


  } catch (error) {
    console.error('Failed to remove item:', error);
  }
};


  return (
    <>
          <section className='my-4'>
        <div className='px-4'>
          <p className='page-heading'>My Insights</p>
          <p className='para-text text-muted'>Get Quick Insights for multiple indexes & trends in the market.</p>

          {!isEditMode && (
            <button className='about-btn mb-3' onClick={() => setShowForm(!showForm)}>
              {showForm ? 'CANCEL' : 'POST +'}
            </button>
          )}


          <div className="row mt-3">

                      {showForm && (
              <div className="col-12 my-2">
                <div className="insight-card p-3">
                  <p className="page-heading">{isEditMode ? 'Edit this Insight' : 'Post An Insight'}
{isEditMode && selectedIns.image && (
  <div className="d-flex flex-wrap gap-2 mt-2">
    {selectedIns.image.split(',').map((img, i) => (
      <img
        key={i}
        src={`https://api.tradeintell.com/uploads/${img}`}
        alt="Insight"
        style={{
          width: 60,
          height: 60,
          objectFit: 'cover',
          borderRadius: 5
        }}
        className="cursor-pointer"
        onClick={() =>
          window.open(
            `https://api.tradeintell.com/uploads/${img}`,
            '_blank'
          )
        }
      />
    ))}
  </div>
)}
                  </p>

                  <form onSubmit={handleSubmit} className='mt-3'>


                    <input
                      type="text"
                      name="title"
                      placeholder="Add Title*"
                      value={formData.title}
                      onChange={handleChange}
                      className="contact-control bg-white"
required
                    />
<select
  name="category"
  value={formData.category}
  onChange={handleChange}
  className="contact-control bg-white text-muted px-2"

>
  <option value="">Select Category</option>
  {myIndex.map((idx) => (
    <option key={idx.id} value={idx.index_name}>
      {idx.index_name}
    </option>
  ))}
</select>


                    <textarea
                      name="description"
                      placeholder="Mention Details here..* (Seperate by \ for New Line)"
                      value={formData.description}
                      onChange={handleChange}
                      className="contact-control bg-white"
                      rows="10"
                      required
                    />

<input
  type="file"
  name="image"
  accept="image/*"
  onChange={handleImageChange}
  className="contact-control bg-white"
  multiple
/>


                                        <textarea
                      name="impact"
                      placeholder="Describe Impact of your insight"
                      value={formData.impact}
                      onChange={handleChange}
                      className="contact-control bg-white mt-2"
                      rows="3"
                    />

<div className='d-flex'>
                    <button
                      type="submit"
                      className="header-btn py-2 w-100 mt-3"
                      disabled={loading}
                    >
                      {loading ? 'Saving...' : isEditMode ? 'Update Details' : 'Save'}
                    </button>
                    {isEditMode &&
                                        <button
                      type="submit"
                      className="header-btn py-2 w-100 mt-3 bg-danger ms-3"
                      onClick={() => {
                        setShowForm(false);
                              setIsEditMode(false);
      setSelectedIns('');
      setFormData({
        topic: '',
        edu_link: '',
        description: '',
      });
                      }}
                    >Cancel</button>
                    }
                    </div>
                    </form>

                  </div>
                  </div>)}

            {insights.length > 0 ? (
              insights.map((el) => (
                <div className="col-md-6 col-12 my-2" key={el.id}>
                  <div className="insight-card h-100">

                    <img src={el.image != null ? `https://api.tradeintell.com/uploads/${el.image.split(',')[0]}` : InsightImg} className='insight-img' />

<div className='p-2'>
                    <p className='para-text text-muted fw-semibold'>{formatDate(el.posted_on)}</p>
                    <p className="page-heading">{el.title}</p>
                    {/* <p className='para-text'>{el.description}</p>

{el.impact && el.impact.trim() !== '' && (
  <p className='para-text'>● Impact: {el.impact}</p>
)} */}
<pre className='para-text preserve-lines'>
  {el.description}
</pre>

{el.impact && el.impact.trim() !== '' && (
  <pre className='para-text preserve-lines'>
    ● Impact: {el.impact}
  </pre>
)}


<div className='d-flex'>
                    <button className='header-btn w-100 py-2' onClick={() => handleManage(el)}>
                      Manage
                    </button>               
                    
                    <button className='header-btn w-100 py-2 ms-3' onClick={() => {setShowDelete(true); setSelectedIns(el) }}>
                      Remove
                    </button>
                  </div>
{/* flex ends */}

</div>



                  </div>
                </div>
              ))
            ) : (
              <p>No Insights posted yet.</p>
            )}


</div>
{/* row ends */}


</div>
</section>


{showDelete && (
  <>
<section className='dialog-outer'>
<div className='dialog-inner'>

<p className='page-heading'>Delete Insight Posted on {formatDate(selectedIns.posted_on)}.</p>

<div className='d-flex justify-content-center mt-4'>
                    <button className='header-btn py-2' onClick={() => handleRemove(selectedIns.id)}>
                      Confirm
                    </button>               
                    
                    <button className='header-btn py-2 ms-3 bg-danger' onClick={() => {setShowDelete(false); setSelectedIns('') }}>
                      Cancel
                    </button>
                  </div>
{/* flex ends */}

</div>
</section>
  </>
)}

      {loading && <Loading setLoading={setLoading} />}

    </>
  )
}

export default MyInsights